// function openTab(evt, cityName) {
//   var i, tabcontent, tablinks;
//   tabcontent = document.getElementsByClassName("tabcontent-cus");
//   for (i = 0; i < tabcontent.length; i++) {
//     tabcontent[i].style.display = "none";
//   }
//   tablinks = document.getElementsByClassName("tablinks-cus");
//   for (i = 0; i < tablinks.length; i++) {
//     tablinks[i].className = tablinks[i].className.replace(" active", "");
//   }
//   document.getElementById(cityName).style.display = "block";
//   evt.currentTarget.className += " active";
// }
// if (document.getElementById("tab-cus-active")) {
//   document.getElementById("tab-cus-active").click();
// }


document.querySelectorAll("[class^='collection-tabs-'],[class*=' collection-tabs-']")?.forEach(wrapper => {
  tabControls(wrapper)
})

function tabControls(wrapper) {
  const tabs = wrapper.querySelectorAll('.tab-buttons .tab-button');
  const tabPanes = wrapper.querySelectorAll('.tab-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
        const targetTab = `#`+ tab.getAttribute('data-tab');
  
        // Remove active class from all tabs and tab content
        tabs.forEach(t => t.classList.remove('active'));
        tabPanes.forEach(pane => pane.classList.remove('active'));
  
        // Add active class to the clicked tab and corresponding content
        tab.classList.add('active');
        wrapper.querySelector(targetTab).classList.add('active');

        if(wrapper.querySelector('.is-sticky')) {
          wrapper.querySelector(targetTab).scrollIntoView({
            behavior: 'smooth',  // smooth scroll
            block: 'start'
          }); 
        }

        requestAnimationFrame(function () {
          var pane = wrapper.querySelector(targetTab);
          syncCtNavCarousel(pane && pane.querySelector('carousel-slider.tab-slider-container'));
        });
    });
  });
}

/** Mobile only: arrow strip height matches first .image-cont (collection-tabs + popular-categories; multiple sections supported). */
function syncCtNavCarousel(carousel) {
  if (!carousel || !carousel.querySelector('.enable-carousel-arrows')) return;
  if (!window.matchMedia('(max-width: 767.98px)').matches) {
    carousel.style.removeProperty('--ct-nav-image-height');
    return;
  }
  var cont = carousel.querySelector('.image-cont');
  if (!cont) return;
  var h = cont.offsetHeight;
  if (h < 2) {
    carousel.style.removeProperty('--ct-nav-image-height');
    return;
  }
  carousel.style.setProperty('--ct-nav-image-height', h + 'px');
}

function bindCtNavCarousel(carousel) {
  if (!carousel || !carousel.querySelector('.enable-carousel-arrows')) return;
  var cont = carousel.querySelector('.image-cont');
  if (!cont) return;
  function sync() {
    syncCtNavCarousel(carousel);
  }
  sync();
  if (window.ResizeObserver) {
    if (carousel._ctNavRO) carousel._ctNavRO.disconnect();
    carousel._ctNavRO = new ResizeObserver(sync);
    carousel._ctNavRO.observe(cont);
  }
}

function initCtNavCarousels(scope) {
  var root = scope || document;
  root.querySelectorAll('.collection-tabs-section carousel-slider.tab-slider-container').forEach(bindCtNavCarousel);
}

initCtNavCarousels(document);

window.addEventListener('on:debounced-resize', function () {
  document.querySelectorAll('.collection-tabs-section carousel-slider.tab-slider-container').forEach(syncCtNavCarousel);
});

document.addEventListener('shopify:section:load', function (e) {
  if (!e.target.classList.contains('collection-tabs-section')) return;
  var wrap = e.target.querySelector("[class^='collection-tabs-'], [class*=' collection-tabs-']");
  if (wrap) tabControls(wrap);
  initCtNavCarousels(e.target);
});
